import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../styles/VideoPhotos.scss';
import Title from './common/Title';
import SliderNavigation from './common/SliderNavigation';

const VideoPhotosSkeleton = () => {
  return (
    <section className="video-photos">
      <Title text="VIDEO & PHOTOs" />

      <div className="video-photos-container">
        {/* Left side images skeleton */}
        <div className="side-images left">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="side-image-container">
              <Skeleton height={150} width="100%" />
            </div>
          ))}
        </div>

        {/* Main slider skeleton */}
        <div className="main-slider">
          <SliderNavigation
            onPrevClick={() => {}}
            onNextClick={() => {}}
            canPrev={false}
            canNext={false}
          />
          <div className="slider-content">
            <Skeleton height={300} width="100%" />
            <div className="slider-info">
              <Skeleton width={100} height={15} />
              <Skeleton width="70%" height={20} />
              <Skeleton width="60%" height={15} />
            </div>
            <div className="image-overlay">
              <button className="play-button large" disabled>
                <Skeleton circle width={50} height={50} />
              </button>
            </div>
          </div>
        </div>

        {/* Right side images skeleton */}
        <div className="side-images right">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="side-image-container">
              <Skeleton height={150} width="100%" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoPhotosSkeleton;
